import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppSelector } from '../store/useStore';
import { IMarketPriceFilter } from '../../constants/filter/marketPriceFilter.constant';
import { marketPricePageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { createSearchParamBySelectedFilterOption } from '../../utils/filter/createSearchParamBySelectedFilterOption.util';

export const useUpdateMarketPriceListPageSearchParam = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const marketPriceFilterStates = useAppSelector((state) => state.filter.marketPriceFilter);

  useEffect(() => {
    if (marketPriceFilterStates.isSearchParamChecked && marketPriceFilterStates.globalFilters) {
      const existingParams = Object.fromEntries(searchParams.entries());

      const newFilterParams = createSearchParamBySelectedFilterOption({
        filterType: 'marketPriceFilter',
        filters: marketPriceFilterStates.globalFilters as IMarketPriceFilter[],
      });

      const mergedParams = {
        ...existingParams,
        ...newFilterParams,
      };

      const newSearchParams = new URLSearchParams(mergedParams).toString();

      navigate(`${marketPricePageInfo.listPage.path}?${newSearchParams}`, {
        replace: true,
      });
    }
  }, [marketPriceFilterStates.globalFilters, marketPriceFilterStates.isSearchParamChecked, searchParams]);
};
